import { Download } from 'lucide-react';
import './FileAttachment.css';

interface FileAttachmentProps {
  fileName: string;
  fileType: string;
  fileUrl: string;
  onDownload: () => void;
}

export function FileAttachment({ fileName, fileType, onDownload }: FileAttachmentProps) {
  const getFileIcon = (type: string) => {
    if (type.startsWith('application/pdf')) return '📄';
    if (type.startsWith('application/zip')) return '🗜️';
    if (type.startsWith('application/msword') || type.includes('document')) return '📝';
    if (type.startsWith('application/vnd.ms-excel') || type.includes('spreadsheet')) return '📊';
    if (type.startsWith('application/vnd.ms-powerpoint') || type.includes('presentation')) return '📽️';
    if (type.startsWith('text/')) return '📃';
    if (type.startsWith('audio/')) return '🎵';
    return '📎';
  };

  const getFileExtension = (name: string) => {
    const parts = name.split('.');
    return parts.length > 1 ? `.${parts[parts.length - 1]}` : '';
  };

  return (
    <div className="file-attachment">
      <div className="file-icon">
        {getFileIcon(fileType)}
      </div>
      <div className="file-info">
        <div className="file-name" title={fileName}>{fileName}</div>
        <div className="file-meta">
          <span className="file-type">{getFileExtension(fileName)}</span>
        </div>
      </div>
      <button
        onClick={onDownload}
        className="file-download-btn"
        title="Fazer download"
      >
        <Download size={20} />
      </button>
    </div>
  );
}
